export function writableRecommendationFields(fields) {
  return fields.map(({ id, weight }) => ({ id, weight }));
}

export function recommendationFieldWriteError(result) {
  const failed = Object.values(result || {}).find(entry => entry?.errors?.length);
  if (!failed) return null;

  return failed.errors.map(error => (
    `${error.key}: ${error.message}`
  )).join('; ');
}
